module.exports = __webpack_public_path__ + "static/media/create-edited.2b5e85f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/create-edited.png
// module id = 619
// module chunks = 0